<template>
    <w-btn
        color="teal"
        outlined
        :loading="loading"
        :text="$t('common.close')"
        icon="mdi-close"
        @press="press"
    />
</template>

<script>
export default {
    name: 'WBtnClose',
    props: {
        loading: Boolean,
    },
    emits: ['press'],
    setup(props, {emit}) {
        function press() {
            emit('press');
        }

        return {
            press,
        }
    }
}
</script>

<style scoped>

</style>